import React, { useMemo, useRef } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Colors } from "@mediamath/design-system-eng";
import LeftContent from "reports/data-export/data-export-list/components/footer/LeftContent";
import useToggleStatus from "reports/data-export/data-export-list/hooks/useToggleStatus";
import RightContent from "reports/data-export/data-export-list/components/footer/RightContent";
import useDataExportUpdate from "reports/data-export/data-export-list/hooks/useDataExportUpdate";

const StFooterContainer = styled.div`
  bottom: -100px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  margin-left: -6.5px;
  position: fixed;
  width: 100%;
  transition: transform 0.3s ease-in-out;

  &.footer-visible {
    transform: translateY(-100px);
  }

  .p-toolbar {
    background-color: ${Colors.ColorGrey000};
  }
`;

const Footer = ({ props = {} }) => {
  const toastRef = useRef(null);
  const { isSending, postData } = useDataExportUpdate();
  // Destructured props are called "props" by PrimeReact which confuses ESLint, hence disable warning
  /* eslint-disable react/prop-types */
  const tableRef = props.customprop;
  const reports = props.selection;
  const numSelected = reports?.length;

  const toggleStatus = useToggleStatus({
    reportsList: reports,
    postData,
    toastRef,
  });

  const leftContent = useMemo(() => {
    return (
      <LeftContent
        isSending={isSending}
        numSelected={numSelected}
        selectedReports={reports}
        tableInstance={tableRef.current}
        toggleStatus={toggleStatus}
      />
    );
  }, [isSending, numSelected, reports, tableRef, toggleStatus]);

  const rightContent = useMemo(() => {
    return <RightContent isSending={isSending} />;
  }, [isSending]);

  return (
    <section>
      <Toast ref={toastRef} />
      <StFooterContainer className={numSelected ? "footer-visible" : ""}>
        <Toolbar left={leftContent} right={rightContent} />
      </StFooterContainer>
    </section>
  );
};

Footer.propTypes = {
  props: PropTypes.shape({
    customprop: PropTypes.shape({ current: PropTypes.node }),
    selection: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

export default Footer;
